'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const SOCIAL_WINDOW_PARAMS = 'width=640,height=480,toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,copyhistory=no,resizable=yes';

function SocialShareButton(el, windowParams) {
  this.windowParams = windowParams || SOCIAL_WINDOW_PARAMS;
  this.url = el.dataset.shareUrl;
  el.addEventListener('click', evt => {
    evt.preventDefault();
    window.open(this.url, 'socialWindow', this.windowParams);
  });
}

exports.default = SocialShareButton;
